const UNITS = {
  SLEEPING_DURATION:                "hours",
  SLEEPING_AVG_HR:                  "bpm",
  SLEEPING_MIN_HR:                  "bpm",
  SLEEPING_MAX_HR:                  "bpm",
  SLEEPING_AVG_HRV:                 "hrv",
  SLEEPING_MIN_HRV:                 "hrv",
  SLEEPING_MAX_HRV:                 "hrv",
  SLEEPING_AVG_HRV_RMSSD:           "milliseconds",
  SLEEPING_MIN_HRV_RMSSD:           "milliseconds",
  SLEEPING_MAX_HRV_RMSSD:           "milliseconds",
  SLEEPING_AVG_RESPIRATION:         "breaths_per_min",
  SLEEPING_MIN_RESPIRATION:         "breaths_per_min",
  SLEEPING_MAX_RESPIRATION:         "breaths_per_min",
  SLEEPING_POSTURE_TRANSITIONS:     "transitions",
  SLEEPING_COMBINED_ACT_COUNT:      "count",
  RESTING_DURATION:                 "hours",
  RESTING_LYING_DURATION:           "hours",
  RESTING_SITTING_DURATION:         "hours",
  RESTING_STANDING_DURATION:        "hours",
  RESTING_AVG_HR:                   "bpm",
  RESTING_MIN_HR:                   "bpm",
  RESTING_MAX_HR:                   "bpm",
  RESTING_AVG_HRV:                  "hrv",
  RESTING_MIN_HRV:                  "hrv",
  RESTING_MAX_HRV:                  "hrv",
  RESTING_AVG_HRV_RMSSD:            "milliseconds",
  RESTING_MIN_HRV_RMSSD:            "milliseconds",
  RESTING_MAX_HRV_RMSSD:            "milliseconds",
  RESTING_UPRIGHT_POSTURE_DURATION: "hours",
  RESTING_LEANING_POSTURE_DURATION: "hours",
  RESTING_COMBINED_ACT_COUNT:       "count",
  MOVING_DURATION:                  "hours",
  MOVING_WALKING_DURATION:          "hours",
  MOVING_OTHER_DURATION:            "hours",
  MOVING_AVG_HR:                    "bpm",
  MOVING_MIN_HR:                    "bpm",
  MOVING_MAX_HR:                    "bpm",
  MOVING_AVG_HRV:                   "hrv",
  MOVING_MIN_HRV:                   "hrv",
  MOVING_MAX_HRV:                   "hrv",
  MOVING_AVG_HRV_RMSSD:             "milliseconds",
  MOVING_MIN_HRV_RMSSD:             "milliseconds",
  MOVING_MAX_HRV_RMSSD:             "milliseconds",
  MOVING_AVG_GAIT_CADENCE:          "steps_per_min",
  MOVING_STEPS:                     "steps",
  MOVING_COMBINED_ACT_COUNT:        "count"
};

const COLORS = {
  "SLEEPING:ASLEEP":  ["#2f3682", "#cbcbcb"],
  "RESTING:LYING":    ["#65c4d3", "#d6d6d6"],
  "RESTING:SITTING":  ["#217360", "#cbcbcb"],
  "RESTING:STANDING": ["#74c636", "#c3c3c3"],
  "MOVING:WALKING":   ["#f5ca23", "#a8a8a8"],
  "MOVING:OTHER":     ["#ff6f00", "#969696"],
  "UNKNOWN":          ["#f1f1f1", "#f1f1f1"]
};

let MetricUtil = {
  UNITS,
  COLORS,
  METRICS: Object.keys(UNITS),

  precision: function (key) {
    if (key.match(/HRV$/)) {
      return 2;
    }
    if (UNITS[key] === "milliseconds") {
      return 1;
    }

    return 0;
  }
};

module.exports = MetricUtil;